module.exports = __webpack_public_path__ + "d1c3963c792c3ec8d05ee4f29dbd3334.pdf";